'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = promoteDynamicContent;

var _hudlBase = require('hudl-base');

function promoteDynamicContent() {
  var comScoreId = '24620524';

  // fire Comscore dynamic tag
  self.COMSCORE && COMSCORE.beacon({ c1: '2', c2: comScoreId });

  // get pageview candidate
  _hudlBase.Xhr.instance.get('/api/v2/profiles/comscore/pageview-candidate').done(function (result) {
    return result;
  });
}